import { DEFAULT_VOTE_OPTIONS } from "@tree-company/discussit-embed";

export const voteOptions = DEFAULT_VOTE_OPTIONS.filter(
  ({ type }) => type === "like",
);
